import apiClient from "./apiClient";

export const listTaxonomyValues = (category) => apiClient.get(`/taxonomy/${category}`);

export const createTaxonomyValue = (category, payload) =>
  apiClient.post(`/taxonomy/${category}`, {
    ...payload,
    category,
  });

export const updateTaxonomyValue = (category, valueId, payload) =>
  apiClient.patch(`/taxonomy/${category}/${valueId}`, payload);
